import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Step} from '../../../core/api/resources/step.resource';

@Component({
  selector: 'unr-roadtrip-steps',
  templateUrl: 'roadtrip-steps.component.html',
  styleUrls: [
    'roadtrip-steps.component.scss'
  ]
})
export class UnrRoadtripStepsComponent implements AfterViewInit {

  selectedSlide = 0;
  afterInit = false;
 swiperBreakpoints = {
    0: { slidesPerView: 3.2, spaceBetween: 5 },
    768: { slidesPerView: 6.25, spaceBetween: 0 }
  };
  @Input()
  set initialSlide(nr) {
    this.selectedSlide = nr;
    if (this.afterInit) {
      this.slides.slideTo(this.selectedSlide);
    }
  }

  get initialSlide(): number {
    return this.selectedSlide;
  }

  @Input() steps: Step[] = [];
  @Output() onStepTap: EventEmitter<Step> = new EventEmitter<Step>();
  @ViewChild('slides', {static: false}) slides;

  sliderOptions = {
    initialSlide: this.initialSlide,
    slidesPerView: 3.25,
    spaceBetween: 5
  };

  ngAfterViewInit(): void {
    if (!this.afterInit && this.slides) {
      this.slides.slideTo(this.selectedSlide)
        .then(() => {
          this.afterInit = true;
        });
    }
  }
}
